import Settings from './settings';

const saveNewTheme = (newTheme, ingredient) => {
  if (typeof newTheme === 'object' && typeof ingredient === 'object') {
    const newThemeArr = Object.keys(newTheme); // const ingredientArr = Object.keys(ingredient);

    newThemeArr.forEach(key => {
      if (newTheme[key] && ingredient[key]) {
        if (typeof newTheme[key] === 'object' && typeof ingredient[key] === 'object') {
          saveNewTheme(newTheme[key], ingredient[key]);
        } else if (typeof newTheme[key] === 'string' && typeof ingredient[key] === 'string') {
          ingredient[key] = newTheme[key];
        }
      } else {
        ingredient[key] = newTheme[key];
      }
    });
  }
};
/**
 * set theme setting as global
 * @param {Object} theme
 */


export const setTheme = theme => {
  if (theme && typeof theme === 'object') {
    const themeKeys = Object.keys(theme);
    themeKeys.forEach(key => {
      const newTheme = theme[key];
      const ingredient = Settings[key];

      if (newTheme && ingredient) {
        saveNewTheme(newTheme, ingredient);
      }
    });
  }
};
export const useTheme = () => Settings;